import React from 'react';
import { Hero } from './Hero';

export const Home: React.FC = () => {
  return <Hero />;
};
